"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _useElementChildren = _interopRequireDefault(require("./useElementChildren"));

var _util = require("../util");

// Handle keydown and keyup in Dropdown
var useDropdownKeyboard = function useDropdownKeyboard(_ref) {
  var open = _ref.open,
      overlay = _ref.overlay,
      highlightedItemKey = _ref.highlightedItemKey,
      handleArrowEvent = _ref.handleArrowEvent,
      selectedKey = _ref.selectedKey,
      isNavByArrowsDisabled = _ref.isNavByArrowsDisabled;
  // Get all DropdownMenuItem as a flattened array when the dropdown is open
  var menuItemsArray = (0, _useElementChildren["default"])({
    children: overlay,
    // Can't use DropdownMenuItem type as the filter, because the menu item type will be EmotionCSSPropInternal in some situation
    prop: 'itemKey',
    hasCondition: isNavByArrowsDisabled ? false : open
  }); // Get all DropdownMenuItem keys as an array

  var menuItemKeys = (0, _react.useMemo)(function () {
    if (menuItemsArray && menuItemsArray.length) {
      return menuItemsArray
      /* eslint-disable react/prop-types */
      .filter(function (_ref2) {
        var props = _ref2.props;
        return props && !props.header && !props.disabled;
      }) // Filter out header/disabled item in the group

      /* eslint-disable react/prop-types */
      .map(function (_ref3) {
        var props = _ref3.props;
        return props.itemKey;
      });
    }

    return [];
  }, [menuItemsArray]);
  var hoveredIndex = menuItemKeys.findIndex(function (key) {
    return key === (0, _util.firstNonUndefined)([highlightedItemKey, selectedKey]);
  }); // Handle navigate menu items through up/down arrow keys

  var handleKeyDown = (0, _react.useCallback)(function (e) {
    if (isNavByArrowsDisabled) return;

    if (e.key === 'ArrowUp') {
      // Up arrow
      handleArrowEvent(e, (0, _util.firstNonUndefined)([menuItemKeys[hoveredIndex - 1], menuItemKeys[menuItemKeys.length - 1]]));
    } else if (e.key === 'ArrowDown') {
      // Down arrow
      handleArrowEvent(e, (0, _util.firstNonUndefined)([menuItemKeys[hoveredIndex + 1], menuItemKeys[0]]));
    }
  }, [handleArrowEvent, hoveredIndex, isNavByArrowsDisabled, menuItemKeys]);
  var onKeyUp = (0, _react.useCallback)( // Listen to keyup instead of keydown, because Drawer component listen to keyup (escape key) too
  // need to stop propagating the event to Drawer
  function (e, _ref4) {
    var handleEscape = _ref4.handleEscape;

    if (e.key === 'Escape') {
      e.stopPropagation();
      e.preventDefault(); // Escape key

      handleEscape();
    }
  }, []);
  return {
    handleKeyDown: handleKeyDown,
    onKeyUp: onKeyUp
  };
};

var _default = useDropdownKeyboard;
exports["default"] = _default;
//# sourceMappingURL=useDropdownKeyboard.js.map